var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTisco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M0,35.2c7.7,0,15.5-0.1,23.1,0.1c0,4.5,0,8.9,0,13.4 c-1.4,0-2.9,0-4.3,0c0,14.6,0,29.3,0,43.9c-4.8,0-9.8,0.1-14.5-0.1c0-14.6,0-29.2,0-43.9c-1.4,0-2.8,0-4.3,0C0,44.2,0,39.7,0,35.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M26.4,35.3c4.8,0,9.6,0,14.4,0c0,19.1,0,38.2,0,57.3 c-4.8,0-9.7,0-14.5,0c0-19,0-38.1,0-57.1C26.4,35.4,26.3,35.3,26.4,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M67,36.9c0,4,0,8,0,11.9c-0.3,0.1-0.5-0.4-0.8-0.6 c-2.2-1.6-5.5,0-5.8,2.6c-0.1,1.2,0.3,2.6,0.5,3.9c0.8,3.7,1.8,7.2,2.8,10.5c1.4,4.4,3.4,9.1,3,14.7c-0.4,5.3-2.8,9.1-6.6,11.2 c-1.9,1.1-4.4,1.7-7.2,1.5c-2.7-0.2-4.8-0.8-7.1-1.8c0-4.4,0-8.7,0-13.1c0.2-0.1,0.6,0.2,0.9,0.4c0.3,0.2,0.6,0.4,1,0.5 c2.3,0.8,5.1-0.3,5.3-2.7c0.2-2.1-0.5-4.5-1.1-6.4c-1.8-5.7-4.3-10.6-5.4-17.2c-0.8-4.9-0.1-9,2.3-12.1c1.1-1.4,2.5-2.6,4.1-3.4 c1.6-0.9,3.4-1.6,5.7-1.8C62.1,35,64.5,36.1,67,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M90.2,35.3c0,4.1,0,8.2,0,12.3c-3.7-0.4-6.1,0.5-6.9,3.1 c-0.5,1.6-0.2,4.3-0.2,6.4c0,4.5,0,8.7,0,13.2c0,2.2-0.3,4.7,0.2,6.4c0.7,2.8,3.3,3.8,7,3.4c0,4.1,0,8.2,0,12.3 c-7.9,0.4-13-2.4-16.2-6.9c-1.7-2.3-2.8-5-3.2-8.3c-0.2-1.7-0.1-3.7-0.1-5.7c0-5.7,0-11.5,0-17.3c0-2,0-3.8,0.3-5.5 c0.9-4.5,3.6-8.2,6.8-10.5C80.9,36.2,84.8,34.9,90.2,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M110.3,35.3c7.2-0.5,12.1,3.4,14.9,7.7c1.6,2.5,2.6,5.2,2.7,8.6 c0.2,4.1,0,7.5,0,11.3c0,3.7,0,7.5,0,11.3c0,3.7-0.6,6.9-2,9.3c-2.6,4.8-7.2,8.4-13.7,8.9c-3.6,0.3-6.7-0.8-9.1-2.1 c-2.3-1.3-4.4-3.2-5.8-5.5c-1.5-2.3-2.6-5.2-2.7-8.6c-0.2-7.5,0-15.2,0-22.6c0-4.1,0.6-6.6,2-9.3c1.9-3.6,4.8-6.5,9-8 C107,35.8,108.6,35.5,110.3,35.3z M107.3,50.4c-0.7,1.7-0.4,4.5-0.4,6.4c0,4.5,0,9.2,0,13.7c0,2.4-0.3,5,0.2,6.6 c0.8,2.4,3.4,3.9,5.8,2.8c0.9-0.4,2-1.5,2.4-2.8c0.5-1.6,0.2-4.5,0.2-6.4c0-4.7,0-8.9,0-13.3c0-2.3,0.3-4.9-0.2-6.5 c-0.6-1.9-2.3-3.5-4.7-3.1C108.9,47.9,107.9,49.1,107.3,50.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTisco);
export default __webpack_public_path__ + "static/media/tisco.f8e246d6e1788343d52bab8375c770c1.svg";
export { ForwardRef as ReactComponent };